import React, { Component, PropTypes } from 'react';
import Input from '../input';
import Card from '../tc-ui/card';
import { setOnboardingFields } from '../../stores/onboarding/onboarding-actions';
import Select from 'react-select';
import languagesObj from '../../localization/languages.json';
import { countries } from '../../utils/select-fields';
const languageSettings = languagesObj['en-US'];

class ContactInfo extends Component {

  setCountry = ({ value: country }) => {
    const { dispatch } = this.props;
    return dispatch(setOnboardingFields({ country }));
  };

  render() {
    return (
      <Card
        className="on-boarding-card"
        title={languageSettings.onboarding.contactInfo}
        subtitle={languageSettings.onboarding.required}
      >


        <div className="l-paper-split-form">
          <div className="field">
            <div className="l-paper-left">
              <label className="form-label"></label>
            </div>
            <div className="l-paper-right">
              <p>{languageSettings.onboarding.contactInfoParagraph}</p>
            </div>
          </div>
        </div>


        <div className="l-paper-split-form">
          <div className="field">

            <div className="l-paper-left">
              <label htmlFor="contactFirstName" className="form-label">{languageSettings.onboarding.contact}</label>
            </div>
            <div className="l-paper-right">
              <div className="form-line">
                <div className="form-line-two">
                  <Input name="contactFirstName" id="contactFirstName" defaultValue={this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactFirstName : this.props.user.firstName} placeholder={languageSettings.onboarding.firstName} type={"text"} required="true" />
                </div>
                <div className="form-line-two">
                  <Input name="contactLastName" defaultValue={this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactLastName : this.props.user.lastName} placeholder={languageSettings.onboarding.lastName} type={"text"} required="true" />
                </div>
              </div>
              <Input name="contactEmail" id="contactEmail" defaultValue={this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactEmail : ''} placeholder={languageSettings.onboarding.email} type={"email"} required="true" />
              <Input name="contactPhone" defaultValue={this.props.prePopulateContactInformation ? this.props.prePopulateContactInformation.contactPhone : ''} placeholder={languageSettings.onboarding.phone} type={"text"} required="true" />
            </div>

            <div className="l-paper-left">
              <label htmlFor="companyAddressLineOne" className="form-label">{languageSettings.onboarding.address}</label>
            </div>
            <div className="l-paper-right" id="address">
              <Input name="companyAddressLineOne" id="companyAddressLineOne" defaultValue={this.props.prePopulateAddress.address_1} placeholder={languageSettings.onboarding.addressOnePlaceholder} type={"text"} required="true" />
              <Input name="companyAddressLineTwo" defaultValue={this.props.prePopulateAddress.address_2} placeholder={languageSettings.onboarding.addressTwoPlaceholder} type={"text"} />
              <Input name="city" defaultValue={this.props.prePopulateAddress ? this.props.prePopulateAddress.city : ''} placeholder={languageSettings.onboarding.city} type={"text"} required="true" />
              <div className="form-line">
                <div className="form-line-two">
                  <Input name="state" defaultValue={this.props.prePopulateAddress ? this.props.prePopulateAddress.state : ''} placeholder={languageSettings.onboarding.statePlaceholder} type={"text"} required="true" />
                </div>
                <div className="form-line-two">
                  <Input name="postalCode" defaultValue={this.props.prePopulateAddress ? this.props.prePopulateAddress.postal_code : ''} placeholder={languageSettings.onboarding.zipPlaceholder} type={"text"} required="true" />
                </div>
              </div>
              <Select
                value={(this.props.onboarding.country)}
                onChange={this.setCountry}
                clearable={false}
                options={countries}
              />
            </div>

            <div className="l-paper-left">
              <label htmlFor="corporatePhone" className="form-label">{languageSettings.onboarding.corporatePhone}</label>
            </div>
            <div className="l-paper-right">
              <Input name="corporatePhone"
                id="corporatePhone"
                defaultValue={this.props.phone}
                type={"text"}
                required="true"
              />
            </div>

            <div className="l-paper-split-form">
              <div className="field">
                <div className="l-paper-left">
                  <label className="form-label"></label>
                </div>
                <div className="l-paper-right">
                  <p className="multi-select-paragraph"><em>{languageSettings.onboarding.phoneInfoParagraph}</em></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

ContactInfo.propTypes = {
  prePopulateAddress: PropTypes.object,
  phone: PropTypes.string,
  onChange: PropTypes.func,
  prePopulateContactInformation: PropTypes.object,
  user: PropTypes.object,
  onboarding: PropTypes.object,
  dispatch: PropTypes.func,
};

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/app/components/onboarding/contact-info.jsx